<template>
    <div class="wallcontainer">
        <h3>Ces sites proposent des pseudo-placements sur :</h3>
            <div class="scrolling-wrapper-flexbox">
                <div class="card"><img src="/img/icon/cryptoactifs.svg"/><h5>LE BITCOIN</h5><p>Apparue au début des années 2010, cette monnaie virtuelle a séduit les jeunes et tous les épargnants en mal de sensations fortes. Les escrocs font croire aux internautes qu'ils peuvent en acquérir facilement sur leur site. En réalité, le produit n'existe pas. Cette arnaque se décline aussi sur toutes les autres cryptomonnaies.</p></div>
                <div class="card"><img src="/img/icon/cheptel.svg"/><h5>CHEPTEL</h5><p>Un rendement « garanti » de 6 % par an en investissant aux côtés d’une société qui loue des vaches à des éleveurs. Le modèle économique semble sérieux:l’agriculteur bénéficierait du lait et des éventuels veaux. L’investisseur récupérerait les velles, faisant grossir son cheptel et, donc, son capital. Cette arnaque vise les épargnants à la recherche de placements « responsables ».</p></div>
                <div class="card"><img src="/img/icon/diamant.svg" alt="un diamant"><h5>DIAMANT</h5><p>Acheter en ligne des diamants à une société qui promet de les stocker pendant 90 jours dans des ports francs en suisse afin de vous éviter de payer de la TVA et des droits de douane. Les précieux cailloux doivent être ensuite revendus à d’autres investisseurs. Un placement annoncé comme « toujours en hausse » voire « garanti » dans cette « valeur refuge ».</p></div>
                <div class="card"><img src="img/icon/forex.svg" alt="une courbe indiquant le forex"><h5>FOREX</h5><p>Le forex (abréviation de FOReign EXchange) est un marché spéculatif sur les devises internationales. Les sites frauduleux proposent des programmes de formation express au métier de « trader » sur ce marché. L’épargnant pourra ensuite acheter et vendre des monnaies internationales depuis son  « espace personnel » sur leur site afin de gagner  « 10 000 € par semaine ».</p></div>
                <div class="card"><img src="/img/icon/options_binaires.svg" alt="une courbe indiquant des options binaires"><h5>OPTIONS BINAIRES</h5><p>Les options binaires sont des instruments financiers qui s’apparentent aux paris sportifs : on n’investit pas dans un bien financier mais on mise sur son évolution, comme par exemple, l’euro face au dollar. Il n’y a que deux fins possibles : soit le trader remporte son pari et gagne une somme connue à l'avance, soit il perd complètement sa mise.</p></div>
                <div class="card"><img src="/img/icon/or.svg" alt="un lingot d'or"><h5>OR</h5><p>L’or est considéré comme une « valeur refuge » qui monte lorsque toutes les autres baissent. Acheter de l’or serait la meilleur manière de se protéger contre les incertitudes du monde actuel et notamment de l’apathie des produits financiers traditionnels proposés par les banques. La fiscalité sur ce métal précieux serait en plus allégée. Dans la réalité, les lingots sur lesquels les épargnants sont censés investir n’existent pas.</p></div>
                <div class="card"><img src="/img/icon/vin_whisky.svg" alt="une bouteille de whisky"><h5>VIN/WHISKY/CHAMPAGNE</h5><p>Acheter des grands crus et les revendre dans quelques années en faisant une grosse plus value, sans avoir besoin de stocker les bonnes bouteilles de  vins/whiky et autres crûs  dans une cave. Un faux « intermédiaire » se charge de gérer tous ces « actifs tangibles de luxe », dont la valeur serait « indépendante des marchés financiers », aux gains supposés de « 8 à 28% par an ! »</p></div>
                <div class="card"><img src="/img/icon/formation_trader.svg" alt="une bouteille de whisky"><h5>FORMATIONS TRADING</h5><p>Des packages de quelques heures de formations au « trading » de crypto-actifs ou au forex facturés plusieurs centaines d’euros. Ils doivent vous permettre de « faire de l'argent facile ». Largement diffusées sur les réseaux sociaux, ces promesses visent plus partriculièrement les jeunes. Ces derniers sont incités financièrement à recruter d’autres clients.</p></div>
            </div>
        <div class="subcontainer">
            <div class="wall1">
                <div class="wall1_subcontainer_1">
                    <img :src="image" class="icon_big"/>
                </div>
                <div class="wall1_subcontainer_2">
                    <p class="text_bloc">{{ text }}</p>
                    <div class="button_block">
                        <button @click="decreaseSelection" class="previous">

                        </button>
                        <button @click="increaseSelection" class="nextImage">

                        </button>
                    </div>
                </div>
            </div>
            <div class="wall2">
                <div class="wall2_subcontainer_1">
                    <div class="blocimages" @mouseover="updateVariant(0)"  :class="{wallimage_active:isActive === 0}">
                        <img
                                src="/img/icon/cheptel.svg"
                                class="icon_small"
                        />
                    </div>
                    <div class="blocimages" @mouseover="updateVariant(1)" :class="{wallimage_active:isActive === 1}">
                        <img src="/img/icon/cryptoactifs.svg" class="icon_small"/>
                    </div>
                    <div class="blocimages" @mouseover="updateVariant(2)" :class="{wallimage_active:isActive === 2}">
                        <img src="/img/icon/diamant.svg" class="icon_small"/>
                    </div>
                    <div class="blocimages" @mouseover="updateVariant(3)" :class="{wallimage_active:isActive === 3}">
                        <img src="img/icon/forex.svg" class="icon_small"/>
                    </div>
                </div>

                <div class="wall2_subcontainer_2">
                        <div class="blocimages" @mouseover="updateVariant(4)" :class="{wallimage_active:isActive === 4}">
                            <img src="/img/icon/options_binaires.svg" class="icon_small"/>
                        </div>
                       <div class="blocimages" @mouseover="updateVariant(5)" :class="{wallimage_active:isActive === 5}">
                        <img src="/img/icon/or.svg" class="icon_small"/>
                    </div>
                    <div class="blocimages" @mouseover="updateVariant(6)" :class="{wallimage_active:isActive === 6}">
                        <img src="/img/icon/vin_whisky.svg" class="icon_small"/>
                    </div>
                    <div class="blocimages" @mouseover="updateVariant(7)" :class="{wallimage_active:isActive === 7}">
                        <img src="/img/icon/formation_trader.svg" class="icon_small"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Wallimages",
        data() {
            return {
                selectedVariant: 1,
                text: "LE BITCOIN. Apparue au début des années 2010, cette monnaie virtuelle a séduit les jeunes et tous les épargnants en mal de sensations fortes. Les escrocs font croire aux internautes qu'ils peuvent en acquérir facilement sur leur site. En réalité, le produit n'existe pas. Cette arnaque se décline aussi sur toutes les autres cryptomonnaies.",
                image: "/img/icon/cryptoactifs.svg",
                isActive : 1,
                variants: [
                    {
                        variantID: 0,
                        variantImage: "/img/icon/cheptel.svg",
                        variantText: "CHEPTEL. Un rendement « garanti » de 6 % par an en investissant aux côtés d’une société qui loue des vaches à des éleveurs. Le modèle économique semble sérieux : l’agriculteur bénéficierait du lait et des éventuels veaux. L’investisseur récupérerait les velles, faisant grossir son cheptel et, donc, son capital. Cette arnaque vise les épargnants à la recherche de placements « responsables »."
        },
                    {
                        variantID: 1,
                        variantImage: "/img/icon/cryptoactifs.svg",
                        variantText: "LE BITCOIN. Apparue au début des années 2010, cette monnaie virtuelle a séduit les jeunes et tous les épargnants en mal de sensations fortes. Les escrocs font croire aux internautes qu'ils peuvent en acquérir facilement sur leur site. En réalité, le produit n'existe pas. Cette arnaque se décline aussi sur toutes les autres cryptomonnaies.",
                    },
                    {
                        variantID: 2,
                        variantImage: "/img/icon/diamant.svg",
                        variantText: "DIAMANT. Acheter en ligne des diamants à une société qui promet de les stocker pendant 90 jours dans des ports francs en Suisse afin de vous éviter de payer de la TVA et des droits de douane. Les précieux cailloux doivent être ensuite revendus à d’autres investisseurs. Un placement annoncé comme « toujours en hausse »  voire « garanti » dans cette « valeur refuge »."
                    },
                    {
                        variantID: 3,
                        variantImage: "img/icon/forex.svg",
                        variantText:"FOREX. Le forex (abréviation de FOReign EXchange) est un marché spéculatif sur les devises internationales. Les sites frauduleux proposent des programmes de formation express au métier de « trader » sur ce marché. L’épargnant pourra ensuite acheter et vendre des monnaies internationales depuis son  « espace personnel » sur leur site afin de gagner  « 10 000 € par semaine »."                     },
                    {
                        variantID: 4,
                        variantImage: "/img/icon/options_binaires.svg",
                        variantText:"OPTIONS BINAIRES. Les options binaires sont des instruments financiers qui s’apparentent aux paris sportifs : on n’investit pas dans un bien financier mais on mise sur son évolution, comme par exemple, l’euro face au dollar. Il n’y a que deux fins possibles : soit le trader remporte son pari et gagne une somme connue à l'avance, soit il perd complètement sa mise."
        },
                    {
                        variantID: 5,
                        variantImage: "/img/icon/or.svg",
                        variantText: "OR. L’or est considéré comme une « valeur refuge » qui monte lorsque toutes les autres baissent. Acheter de l’or serait la meilleur manière de se protéger contre les incertitudes du monde actuel et notamment de l’apathie des produits financiers traditionnels proposés par les banques. La fiscalité sur ce métal précieux serait en plus allégée. Dans la réalité, les lingots sur lesquels les épargnants sont censés investir n’existent pas."                     },
                    {
                        variantID: 6,
                        variantImage: "/img/icon/vin_whisky.svg",
                        variantText: "VIN/WHISKY/CHAMPAGNE. Acheter des grands crus et les revendre dans quelques années en faisant une grosse plus value, sans avoir besoin de stocker les bonnes bouteilles de  vins/whiky et autres crûs  dans une cave. Un faux « intermédiaire » se charge de gérer tous ces « actifs tangibles de luxe », dont la valeur serait « indépendante des marchés financiers », aux gains supposés de « 8 à 28% par an ! »"
                    },
                    {
                        variantID: 7,
                        variantImage: "/img/icon/formation_trader.svg",
                        variantText: "FORMATIONS TRADING. Des packages de quelques heures de formations au « trading »  de crypto-actifs ou au forex facturés plusieurs centaines d’euros. Ils doivent vous permettre de « faire de l'argent facile ». Largement diffusées sur les réseaux sociaux, ces promesses visent plus partriculièrement les jeunes. Ces derniers sont incités financièrement à recruter d’autres clients."  }
                           ]
            }
        },
        methods: {
            updateVariant(index) {
                this.selectedVariant = index;
                this.isActive = index;

            },
            increaseSelection() {
                if (this.selectedVariant < this.variants.length - 1) {
                    this.selectedVariant++;
                } else {
                    this.selectedVariant = 0;
                }
            },
            decreaseSelection() {
                if (this.selectedVariant > 0) {
                    this.selectedVariant--;
                } else {
                    this.selectedVariant = this.variants.length - 1;
                }
            }
        },
        watch: {
            selectedVariant: function () {
                this.text = this.variants[this.selectedVariant].variantText;
                this.image = this.variants[this.selectedVariant].variantImage;
                this.isActive = this.selectedVariant
            }
        }
    };
</script>

<style scoped>


/* RESPONSIVE MOBILE */
@media screen and (min-width:1001px){
    .scrolling-wrapper-flexbox {
        display: none;
       }
}


@media screen and (max-width:1000px) {

    .wallcontainer {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
        height:100%;

    }



    .subcontainer {

        display:none

    }


    .card {
        top:0;
        margin-top:0;
        position:relative;
        flex: 0 0 auto;
        margin-right: 10px;
        margin-left: 10px;
        display:flex;
        flex-direction:column;
        align-items:center;
            }

    .card {
        width: 60vw;
        height: 70vh;
           }


    .card img{
        width:70%;
        height:auto;

    }

    .scrolling-wrapper-flexbox {
        position:relative;
        display: flex;
        overflow-x: auto;
        overflow-y: hidden;
        height:90vh;
        margin-top:0;
        width: 100vw;
        -webkit-overflow-scrolling: touch;

        &::-webkit-scrollbar {
            display: none;
        }
    }


    .wall1_subcontainer_1 {
        display: flex;
        justify-content: center;
        width: 100%;
        height:10vh;
    }

    .icon_big{
        width: 10%;
        height: 10%;
    }


    .wall1_subcontainer_2 {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        width: 80vw;
        height: 50vh;
    }


    .text_bloc {
        position:relative;
        width: 100%;
        height: auto;
        overflow: hidden;
        overflow-wrap: break-word;
        text-align: justify;

    }



}

 /*FIN RESPONSIVE MOBILE*/



    /*-----------CONTAINER--------------------*/
    .wallcontainer {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        height: 90vh;

    }


    .subcontainer {
        position: relative;
        height: 80%;
        width: 80%;

    }

    /*--------------- BLOC DU HAUT----------------*/
    .wall1 {
        width: 100%;
        height: 50%;
        display: flex;
        align-items: flex-start;

    }


    .wall1_subcontainer_1 {
        display: flex;
        justify-content: center;
        width: 50%;
    }


    .wall1_subcontainer_2 {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;
        width: 43%;
        height: 100%;
    }



    .icon_big {

        width: 50%;
        height: 50%;
    }

    .text_bloc {

        position:relative;
        top:5%;
        width: 110%;
        height: 70%;
        overflow: hidden;
        overflow-wrap: break-word;
        text-align: justify;

    }

    .button_block {
        position:relative;
        right:3%;
        display: flex;
        align-items: flex-end;
        justify-content: flex-start;    }

    button {
        width: 70%;
        height: 100%;
        background-color: black;
        color: white;
    }









    /*--------------- BLOC DU BAS----------------*/
    .wall2 {
        width: 100%;
        height:60%;
        display: flex;
        flex-direction: column;

    }
    @media screen and (max-width:1000px){
          .wall2{
              display:none;
          }
           }



    .wall2_subcontainer_1,
    .wall2_subcontainer_2 {
        width: 100%;
        height: 50%;
        display: flex;
        justify-content: space-around;
    }

    .blocimages {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 200px;
        height: 199px;

    }

    .icon_small {
        width: 100%;
        height: 100%;
    }


    div.blocimages :hover {
        background-color:#94c3dd;
    }

    .previous {
        background-image: url("/img/icon/fleche_direction_gauche.svg");
        width: 52px;
        height: 52px;
        background-color: #FFFFFF;
        border: 0;
    }

    .nextImage {
        background-image: url("/img/icon/fleche_direction_droite.svg");
        width: 52px;
        height: 52px;
        background-color: #FFFFFF;
        border: 0;
    }

    .wallimage_active{
        background-color:#94c3dd;
    }

</style>
